import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Data payload for updating a Confluence database.
 */
type ConfluenceUpdateDatabaseData = {
	/**
	 * The title of the database.
	 */
	title: string;
	/**
	 * The csv of the database.
	 */
	document: string;
};

/**
 * Properties for the Confluence database update command.
 *
 * @extends CommandProperties
 */
export interface ConfluenceDatabaseUpdateCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the database update request.
	 */
	key: string;
	/**
	 * The data payload containing the content for updating the database.
	 */
	data: ConfluenceUpdateDatabaseData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
}
/**
 * A command sent by a bridge API client to update a Confluence database.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to update a Confluence database with the specified content.
 */
export const ConfluenceDatabaseUpdateCommand =
	createCommand<ConfluenceDatabaseUpdateCommandProperties>('confluence-database-update-command');
